export default __webpack_public_path__ + "static/media/6.db7150c9.svg";